import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-410934ba"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "total-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_number_value = _resolveComponent("number-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_td = _resolveComponent("b-td");
  return _openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.fields, field => {
    return _openBlock(), _createBlock(_component_b_td, {
      key: field.key,
      class: _normalizeClass([{
        ['b-table-sticky-column']: $options.isTotalColumn(field)
      }])
    }, {
      default: _withCtx(() => [_createVNode(_component_hug_value, {
        class: "total-element",
        styles: {
          justifyContent: $options.getJustify(field),
          padding: '8px'
        },
        loading: $props.loading
      }, {
        default: _withCtx(() => [$options.isTotalColumn(field) ? (_openBlock(), _createElementBlock("span", _hoisted_1, "TOTAL")) : _createCommentVNode("", true), field.key === 'dsp_roas_vs_target' ? (_openBlock(), _createBlock(_component_number_value, {
          key: 1,
          value: $props.total?.[`${_ctx.currentTabValue}_roas`],
          precision: 1,
          tight: ""
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_ecpm' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 2,
          value: $props.total?.[`${_ctx.currentTabValue}_ecpm`],
          precision: 2
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_percent_assisted_sales' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 3
        }, [], 64)) : _createCommentVNode("", true), field.key === 'dsp_new_customers' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 4,
          gap: 16,
          s: ""
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: $props.total?.[`${_ctx.currentTabValue}_new_customers_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`${_ctx.currentTabValue}_new_customers_evol${$data.evolCategory[_ctx.periodCategory]}`],
              align: "right",
              tight: "",
              color: color
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: $props.total?.conversion_new_customers,
            showSymbol: false,
            align: "left",
            valueAlign: "left",
            allowPrecisionModification: false,
            precision: $props.total?.conversion_new_customers > 1000000 ? 1 : 0
          }, null, 8, ["value", "precision"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'dsp_cpa_conversion' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 5,
          valueAlign: "right",
          value: $props.total?.conversion_cpa_ntb,
          precision: 2
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_cpa_consideration' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 6,
          valueAlign: "right",
          value: $props.total?.consideration_cpa_signal,
          precision: 2
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_cpa_loyalty' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 7,
          valueAlign: "right",
          value: $props.total?.loyalty_cpa_repurchase,
          precision: 2
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_spend' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 8,
          value: $props.total?.[`${_ctx.currentTabValue}_spend`],
          allowPrecisionModification: false,
          precision: $props.total?.[`${_ctx.currentTabValue}_spend`] > 1000000 ? 1 : 0
        }, null, 8, ["value", "precision"])) : _createCommentVNode("", true), field.key === 'dsp_assisted_sales' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 9,
          value: $props.total?.[`${_ctx.currentTabValue}_assisted_sales`],
          allowPrecisionModification: false,
          precision: $props.total?.[`${_ctx.currentTabValue}_assisted_sales`] > 1000000 ? 1 : 0,
          valueAlign: "left"
        }, null, 8, ["value", "precision"])) : _createCommentVNode("", true), field.key === 'dsp_percent_assisted_sales' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 10,
          value: $props.total?.[`${_ctx.currentTabValue}_pct_main_assisted_sales`] + $props.total?.[`${_ctx.currentTabValue}_pct_halo_assisted_sales`]
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_units_sold' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 11,
          gap: 8
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: $props.total?.[`${_ctx.currentTabValue}_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`${_ctx.currentTabValue}_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              charCount: _ctx.maxCharCount?.percentage?.[`${_ctx.currentTabValue}_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              align: "right",
              tight: "",
              color: color
            }, null, 8, ["value", "charCount", "color"])]),
            _: 1
          }, 8, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: $props.total?.[`${_ctx.currentTabValue}_units_sold`],
            showSymbol: false,
            allowPrecisionModification: false,
            charCount: _ctx.maxCharCount?.currency?.[`${_ctx.currentTabValue}_units_sold`],
            precision: $props.total?.[`${_ctx.currentTabValue}_units_sold`] > 1000000 ? 1 : 0
          }, null, 8, ["value", "charCount", "precision"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'dsp_atc_clicks' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 12,
          value: $props.total?.[`${_ctx.currentTabValue}_atc_clicks`],
          showSymbol: false,
          allowPrecisionModification: false,
          precision: $props.total?.[`${_ctx.currentTabValue}_atc_clicks`] > 1000000 ? 1 : 0
        }, null, 8, ["value", "precision"])) : _createCommentVNode("", true), field.key === 'dsp_atc_views' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 13,
          value: $props.total?.[`${_ctx.currentTabValue}_atc_views`],
          showSymbol: false,
          allowPrecisionModification: false,
          precision: $props.total?.[`${_ctx.currentTabValue}_atc_views`] > 1000000 ? 1 : 0,
          valueAlign: "left"
        }, null, 8, ["value", "precision"])) : _createCommentVNode("", true), field.key === 'dsp_dpv_clicks' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 14,
          value: $props.total?.[`${_ctx.currentTabValue}_dpv_clicks`],
          showSymbol: false,
          allowPrecisionModification: false,
          precision: $props.total?.[`${_ctx.currentTabValue}_dpv_clicks`] > 1000000 ? 1 : 0
        }, null, 8, ["value", "precision"])) : _createCommentVNode("", true), field.key === 'dsp_dpv_views' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 15,
          value: $props.total?.[`${_ctx.currentTabValue}_dpv_views`],
          showSymbol: false,
          allowPrecisionModification: false,
          precision: $props.total?.[`${_ctx.currentTabValue}_dpv_views`] > 1000000 ? 1 : 0,
          valueAlign: "left"
        }, null, 8, ["value", "precision"])) : _createCommentVNode("", true), field.key === 'dsp_brand_searches' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 16,
          valueAlign: "left",
          value: $props.total?.[`${_ctx.currentTabValue}_brand_searches`],
          showSymbol: false,
          align: "left",
          allowPrecisionModification: false,
          precision: $props.total?.[`${_ctx.currentTabValue}_brand_searches`] > 1000000 ? 1 : 0
        }, null, 8, ["value", "precision"])) : _createCommentVNode("", true), field.key === 'dsp_impressions' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 17,
          value: $props.total?.[`${_ctx.currentTabValue}_viewable_impressions`] + $props.total?.[`${_ctx.currentTabValue}_non_viewable_impressions`],
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          precision: $props.total?.[`${_ctx.currentTabValue}_viewable_impressions`] > 1000000 ? 1 : 0
        }, null, 8, ["value", "precision"])) : _createCommentVNode("", true), field.key === 'dsp_vtr' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 18,
          value: $props.total?.[`${_ctx.currentTabValue}_vtr`]
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_delivery_rate' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 19,
          value: $props.total?.[`${_ctx.currentTabValue}_delivery_rate`]
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_percent_ntb_cust' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 20,
          value: $props.total?.[`${_ctx.currentTabValue}_share_of_ntb`]
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_cvr' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 21,
          value: $props.total?.[`${_ctx.currentTabValue}_cvr_dpv_click_to_purchase`],
          precision: 1
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_post_click_purch' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 22,
          value: $props.total?.[`${_ctx.currentTabValue}_post_click_purchase_ratio`],
          precision: 1
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_halo' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 23,
          value: $props.total?.[`${_ctx.currentTabValue}_halo_effect`],
          precision: 1
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_consideration_signals' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 24,
          gap: 16,
          s: ""
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: $props.total?.[`consideration_signals_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`consideration_signals_evol${$data.evolCategory[_ctx.periodCategory]}`],
              align: "right",
              tight: "",
              color: color
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: $props.total?.consideration_signals,
            showSymbol: false,
            align: "left",
            valueAlign: "left",
            allowPrecisionModification: false,
            precision: $props.total?.consideration_signals > 1000000 ? 1 : 0
          }, null, 8, ["value", "precision"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'dsp_dpv_vs_target' ? (_openBlock(), _createBlock(_component_number_value, {
          key: 25,
          value: $props.total?.consideration_dpvr,
          precision: 1,
          tight: ""
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_dpv' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 26,
          value: $props.total?.consideration_dpv,
          allowPrecisionModification: false,
          precision: $props.total?.consideration_dpv > 1000000 ? 1 : 0,
          valueAlign: "left"
        }, null, 8, ["value", "precision"])) : _createCommentVNode("", true), field.key === 'dsp_atc' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 27,
          valueAlign: "left",
          value: $props.total?.consideration_atc,
          showSymbol: false,
          align: "left",
          allowPrecisionModification: false,
          precision: $props.total?.consideration_atc > 1000000 ? 1 : 0
        }, null, 8, ["value", "precision"])) : _createCommentVNode("", true), field.key === 'dsp_percent_dpv_click' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 28,
          value: $props.total?.consideration_dpv_click_ratio,
          precision: 1
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_repurchases' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 29,
          gap: 16,
          s: ""
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: $props.total?.[`loyalty_repurchases_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`loyalty_repurchases_evol${$data.evolCategory[_ctx.periodCategory]}`],
              align: "right",
              tight: "",
              color: color
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: $props.total?.loyalty_repurchases,
            showSymbol: false,
            align: "left",
            valueAlign: "left",
            allowPrecisionModification: false,
            precision: $props.total?.loyalty_repurchases > 1000000 ? 1 : 0
          }, null, 8, ["value", "precision"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'dsp_percent_existing_cust' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 30,
          value: $props.total?.loyalty_share_of_existing_customers
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_overview_budget' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 31,
          valueAlign: "right",
          value: $props.total?.budget
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_overview_spend' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 32,
          valueAlign: "right",
          value: $props.total?.spend
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_overview_delivery_rate' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 33,
          value: $props.total?.delivery_rate
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_overview_objective' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 34,
          valueAlign: "right",
          value: $props.total?.objective_value,
          showSymbol: false
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_overview_cpa' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 35,
          valueAlign: "right",
          value: $props.total?.cpa,
          precision: 2
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_overview_optimization_kpi' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 36,
          valueAlign: "right",
          value: $props.total?.optimization_value,
          precision: 2,
          showSymbol: false
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_overview_assisted_sales' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 37,
          valueAlign: "right",
          value: $props.total?.assisted_sales
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'dsp_overview_assisted_units_sold' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 38,
          valueAlign: "right",
          value: $props.total?.units_sold,
          showSymbol: false
        }, null, 8, ["value"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["styles", "loading"])]),
      _: 2
    }, 1032, ["class"]);
  }), 128);
}